__turbopack_context__.v({
  "button-highlight": "KEfbxa_button-highlight",
  "moreButton": "KEfbxa_moreButton",
  "tabHighlight": "KEfbxa_tabHighlight",
  "tabRainbow": "KEfbxa_tabRainbow",
});
